// Backend tüm yanıtları { message, data, errorCode, error } zarfıyla döner
// (mobildeki BaseResponse). Bu yardımcılar zarfı açar ve hataları tek tip
// bir ApiError'a çevirir, böylece çağıran katman her zaman aynı şekli görür.

export class ApiError extends Error {
  constructor(message, { code = null, status = null } = {}) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
  }
}

// Başarılı axios yanıtının zarfını açar. errorCode doluysa ApiError fırlatır.
export const unwrap = (response) => {
  const body = response?.data ?? {};
  if (body.errorCode != null) {
    throw new ApiError(body.error || body.message || 'İstek başarısız oldu', {
      code: body.errorCode,
      status: response?.status,
    });
  }
  return body.data;
};

// axios hatasını (network / 4xx / 5xx) okunabilir bir ApiError'a çevirir.
export const toApiError = (error) => {
  if (error instanceof ApiError) return error;

  const res = error.response;
  if (res) {
    const body = res.data || {};
    const message =
      body.error ||
      body.message ||
      `Sunucu hatası (${res.status})`;
    return new ApiError(message, { code: body.errorCode, status: res.status });
  }

  // Yanıt yok: ağ / timeout hatası.
  return new ApiError(
    'Sunucuya bağlanılamıyor. Lütfen internet bağlantınızı kontrol edin.',
    { status: null }
  );
};
